'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.week;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/week.js
// module id = 746
// module chunks = 0